import { useQuery } from '@tanstack/react-query'

import client from '~/clients/api-client'
import { cachedQueriesKeys } from '~/hooks/useWebSocketUpdates/handleWebSocketUpdates'
import { importInboxEntries } from '~/store/di-entity.api'

export const INBOX_ENTRIES_QUERYKEY_PREFIX = 'inboxEntries'

export const useImportInboxEntriesQuery = () =>
    useQuery({
        queryFn: () => importInboxEntries({}),
        queryKey: [INBOX_ENTRIES_QUERYKEY_PREFIX],
        staleTime: 60 * 1000,
    })

export const useUnreadInboxEntriesQuery = () =>
    useQuery({
        queryFn: async () => (await client.getUnreadInboxEntriesCount()).data,
        queryKey: [cachedQueriesKeys.unreadInboxEntriesCount],
        staleTime: 60 * 1000,
    })
